import React, { useState } from "react";
import { toast } from "sonner";
import Layout from "../components/Layout";
import GlassCard from "../components/GlassCard";
import SectionHeader from "../components/SectionHeader";
import DepositButton from "../components/DepositButton";
import { api } from "../lib/kk";

export default function StudWaitlist() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", female_akc_name: "", details: "" });
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/waitlist/stud", form);
      setDone(true);
      toast.success("Stud service request received!");
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <section className="py-20 md:py-24 px-6">
        <div className="max-w-[600px] mx-auto">
          <SectionHeader label="Stud Waitlist" title="Request" highlight="stud service" />
          <GlassCard hover={false} className="p-8">
            {done ? (
              <div className="text-center py-6" data-testid="stud-success">
                <p className="text-[#4CAF50] text-xl font-semibold mb-2">Request received! 🐾</p>
                <p className="text-[#E0E0E0] mb-6">Reserve your breeding slot with a $500 deposit.</p>
                <DepositButton packageId="stud_deposit" label="Pay $500 Stud Deposit" name={form.name} email={form.email} className="w-full" />
              </div>
            ) : (
              <form onSubmit={submit} className="space-y-4" data-testid="stud-form">
                <input className="kk-input" placeholder="Name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="stud-name" />
                <input className="kk-input" type="email" placeholder="Email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="stud-email" />
                <input className="kk-input" placeholder="Phone" required value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="stud-phone" />
                <input className="kk-input" placeholder="Female's AKC Name" required value={form.female_akc_name} onChange={(e) => setForm({ ...form, female_akc_name: e.target.value })} data-testid="stud-akc" />
                <textarea className="kk-input min-h-[120px] resize-none" placeholder="Additional Details" value={form.details} onChange={(e) => setForm({ ...form, details: e.target.value })} data-testid="stud-details" />
                <button type="submit" disabled={loading} className="kk-btn kk-btn-primary w-full rounded-full py-4 disabled:opacity-60" data-testid="stud-submit">
                  {loading ? "Submitting…" : "Request Stud Service"}
                </button>
              </form>
            )}
          </GlassCard>

          <div className="mt-6 text-center">
            <div className="flex items-center gap-3 my-6">
              <div className="h-px bg-white/10 flex-1" />
              <span className="text-[#777] text-xs uppercase tracking-widest">or pay your hold deposit</span>
              <div className="h-px bg-white/10 flex-1" />
            </div>
            <DepositButton packageId="stud_deposit" label="Pay $500 Stud Hold Deposit" name={form.name} email={form.email} className="w-full sm:w-auto" />
          </div>
        </div>
      </section>
    </Layout>
  );
}
